import { useTranslation } from "react-i18next";
import { games as gameQuerys } from "@nualang/nualang-api-and-queries/Queries";
import { getMemberGameAwards } from "@nualang/nualang-api-and-queries/APIs/Games";
import { DateTime } from "luxon";
import { useApp } from "../../hooks";
import AchievementsScreen from "../../components/screens/Achievements/AchievementsScreen";

function Achievements() {
  const { t, i18n } = useTranslation();
  const { user } = useApp();
  const { username } = user;

  const awardsQuery = gameQuerys.useMemberGameAwards(
    getMemberGameAwards,
    { memberId: username },
    { enabled: !!username },
  );

  const medals =
    awardsQuery.isSuccess && Array.isArray(awardsQuery.data?.Items)
      ? awardsQuery.data.Items.filter(
          (item) => item.award && item.award !== "none",
        ).sort((a, b) => (b.awardedAt ?? 0) - (a.awardedAt ?? 0)).map((item) => ({
          color: item.award,
          topicName: item.topicName ?? "",
          courseName: item.courseName ?? "",
          gameType: item.gameType ?? "",
          date: item.awardedAt
            ? DateTime.fromMillis(item.awardedAt).setLocale(i18n.language).toFormat("d MMMM yyyy")
            : "",
        }))
      : [];

  const categories = [
    {
      title: t("live_game_medals"),
      description: t("live_game_medals_description"),
      medals,
    },
  ];

  return (
    <AchievementsScreen
      categories={categories}
      isLoading={awardsQuery.isLoading}
    />
  );
}

export default Achievements;
